import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface LinksDefaultIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: LinksDefaultIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items, ["id"]);

    const curatedLinks = items || [];

    if (!curatedLinks.length) {
        messages.push("Missing curated links.");
    }

    return messages;
}
